// extracted by mini-css-extract-plugin
module.exports = {"formClass":"AddVideoModal_formClass__3oiJI","required":"AddVideoModal_required__3d_P2","submitButton":"AddVideoModal_submitButton__1CZar"};